import type { HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

interface FormMessageProps extends HTMLAttributes<HTMLParagraphElement> {
  variant?: 'muted' | 'error' | 'success'
}

export function FormMessage({
  className,
  variant = 'muted',
  ...props
}: FormMessageProps) {
  return (
    <p
      className={cn(
        'text-sm leading-5',
        variant === 'muted' && 'text-muted-foreground',
        variant === 'error' && 'text-destructive',
        variant === 'success' && 'text-success',
        className,
      )}
      {...props}
    />
  )
}
